export const generateGradientStyle = (colors: string[], degrees: string) => ({
    background: `linear-gradient(${degrees}deg,
        ${colors[0]} 0%,
        ${colors[1]} 30%,
        ${colors[2]} 40%,
        ${colors[0]} 60%,
        ${colors[1]} 80%,
        ${colors[2]} 100%)`,
});
